<template>
    <div id="gheomproduct_view">
        <div class="gheom__header">
            <div class="header__intro">
                <a class="intro__back" href="/" title="Back to dashboard">
                    <i class="icon-bc-arrow"></i>
                </a>
                <div class="intro__page">
                    <div class="page__becrop">
                        <div class="page__becrop__wrap">
                            <img src="/images/logotext_whiteback.svg" class="becrop__logo">
                            <p class="becrop__crop">
                                Potato
                            </p>
                        </div>                    
                    </div>
                    <div class="page__navig">
                        <p>
                            Product <span>Explorer</span>
                        </p>
                    </div>
                </div>
            </div>
            <breadcrumbs
                :current_step="current_stage"
                :current_product="selected_product"
                :current_gheom="selected_gheom"
                :loading="querying_data"
                v-on:onstepchanged="selectStep">
            </breadcrumbs>
        </div>
        <div class="gheom__body">
            <product-grid
                v-if="current_stage == '1'"
                :products="products"
                v-on:onproductselected="selectProduct"
                @manageTooltip="handlingTooltip">
            </product-grid>
        
            <single-product
                v-if="current_stage == '2'"
                :my_selected_product="selected_product"
                v-on:ongheomselected="selectGheom"
                @manageTooltip="handlingTooltip">
            </single-product>

            <single-gheom
                v-if="current_stage == '3'"
                :my_selected_gheom="selected_gheom"
                :my_selected_product="selected_product"
                :the_stages="all_stages"
                :loading="querying_data"
                v-on:onstageselected="selectStage"
                @manageTooltip="handlingTooltip">
            </single-gheom>

            <gheom-overlay
                v-if="over_flag"
                @click="deactivateOverlay">
            </gheom-overlay>
        </div>
    </div>

</template>

<script>
    export default {
        name: "",

        props: {

            products: {
                default: []
            },

            current_crop: {
                default: null,
            }
        },

        data:function(){

            return {
                selected_product: null,
                selected_gheom: null,
                all_stages: null,
                selected_reports: [],

                over_flag: false,

                // old?
                querying_data: false,
                current_stage: 1,

                gheoms: null,
                stages: null,
            }
        },

        methods: {
            /**
             * NEW METHODS
             */

            /**
             * METHOD TO HANDLE PRODUCT SELECTION
             * Data value of product selected is modified, and also the step
             * @param theProduct
             */
            selectProduct(theProduct) {
                let product = theProduct;
                if(!product) return;

                this.selected_product = product;
                this.current_stage = 2;
            },

            /**
             * METHOD TO HANDLE GHEOM SELECTION
             * Data value of gheom selected is modified, and also the step
             * If there are no stages loaded, it will bring them back
             * @param theGheom
             * @param index
             */
            selectGheom(theGheom, index) {
                let gheom = theGheom;
                if(!gheom) return;
                this.selected_gheom = gheom;
                this.current_stage = 3;

                this.all_stages = [];
                //this.selected_reports = [];

                if(this.selected_gheom.stages) {
                    this.all_stages = this.selected_gheom.stages;
                } else {
                    this.getMyStages(this.selected_gheom.id, index)
                }
            },

            selectStage(theStage) {
                console.log("selecting stage");
            },


            /**
             * METHOD TO HANDLE STEP NAVIGATION
             * Data value of step selected is modified
             * This method is triggered by the child breadcrumbs
             * @param step
             */
            selectStep(step) {
                this.current_stage = step;
                if(this.current_stage == "1") {
                    this.selected_product = null;
                    this.selected_gheom = null
                } else if (this.current_stage == "2") {
                    this.selected_gheom = null
                }
            },

            /**
             * METHOD TO HANDLE STAGE RETRIEVING
             * This method retrieves all the stage info of the gheom
             * @param gheom_id
             * @param gheom_index
             */
            getMyStages(gheom_id, gheom_index){
                this.querying_data = true;
                let data = {"gheom_id": gheom_id};
                console.log(data)
                return this.do_ajax("/gheom/stages", data)
                    .then((data)=> {
                        console.log("traigo data");
                        console.log(data);
                        this.callbackGotStagesSuccess(data, gheom_index);
                    })
                    .catch(this.callback_stagesError)
                    .finally(this.callback_stagesFinally);
            },

            callbackGotStagesSuccess(data, index){
                this.selected_gheom.stages = data;
                this.selectGheom(this.selected_gheom, index);
            },

            /**
             * IF THE RETRIEVAL process was wrong then log it //TODO better way
             * @param response
             * @return {number}
             */
            callback_stagesError(error) {
                console.log(error);
                alert('error');
                return 0;
            },

            callback_stagesFinally(){
                this.querying_data = false;
            },

            /**
             * METHOD TO QUERY SERVER API
             * @param url
             * @param data
             * @return {Promise<any>}
             */
            do_ajax(url, data) {

                return new Promise((resolve, reject) => {

                    let callback_ok    = (response) => { resolve(response.data); };
                    let callback_error = (error) => {

                        let error_msg = 'Unknown error :(';
                        if (error.response && error.response.data) {
                            error_msg = error.response.data;
                            if (error.response.data.error)
                                error_msg = error.response.data.error;
                        }

                        reject('Error ' + error_msg);
                    };

                    // Do the call
                    return axios.post(url, data)
                        .then(callback_ok)
                        .catch(callback_error);
                });

            }, // Do ajax

            handlingTooltip() {
                console.log("el manager de tooltips");
                this.over_flag = true;
            },

            deactivateOverlay(){
                console.log("deac");
                this.over_flag = false;
            },


        }
    }
</script>

